const d = 'm280-400 200-201 200 201H280Z';

export default d;
